import type { MatchesCalendarMode } from './types';
import { MatchesCalendarData } from './types';

import type { StateCreator } from '@shared-types/zustand.types';

type FiltersSlice = {
  filters: Record<string, any>;
  setFilters: (payload: Record<string, any>) => void;
};

const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: {},
  setFilters: (payload) => set({ filters: payload }, false, 'setFilters'),
});

type ActiveDataSlice = {
  activeData: Record<MatchesCalendarData, boolean>;
  setActiveData: (payload: Record<MatchesCalendarData, boolean>) => void;
};

const dataSlice: StateCreator<ActiveDataSlice> = (set) => ({
  activeData: {
    [MatchesCalendarData.MATCHES]: true,
    [MatchesCalendarData.FRIENDLIES]: false,
    [MatchesCalendarData.DRAWS]: true,
  },
  setActiveData: (payload) => set({ activeData: payload }, false, 'setActiveData'),
});

type ModeSlice = {
  mode: MatchesCalendarMode;
  setMode: (payload: MatchesCalendarMode) => void;
};

const modeSlice: StateCreator<ModeSlice> = (set) => ({
  mode: null,
  setMode: (payload) => set({ mode: payload }, false, 'setMode'),
});

export type MatchesCalendarState = FiltersSlice & ActiveDataSlice & ModeSlice;

export const reducer: StateCreator<MatchesCalendarState> = (...args) => ({
  ...filtersSlice(...args),
  ...dataSlice(...args),
  ...modeSlice(...args),
});
